<template>
  <a-modal
    class="online-page"
    centered
    title="在线终端"
    :width="'70%'"
    :mask-closable="false"
    :visible="showOnlinePage"
    :confirmLoading="loading"
    :bodyStyle="{ padding: 0 }"
    :footer="null"
    @cancel="close"
  >
    <a-layout id="layout">
      <div class="search-wrapper">
        <a-space>
          <a-date-picker
            v-model="queryParam.day"
            type="date"
            placeholder="登录日期"
            style="width: 100%;"
            valueFormat="YYYY-MM-DD"
          />
          <a-button type="primary" @click="search">查询</a-button>
          <a-button @click="resetSearch">重置</a-button>
        </a-space>
      </div>

      <a-layout-content id="layout-content">
        <a-space class="table-operator">
          <a-dropdown :disabled="selectedRowKeys.length === 0" v-if="accessTo('destroy')">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="destroy()"><a-icon type="delete" />删除</a-menu-item>
            </a-menu>
            <a-button> 批量操作 <a-icon type="down" /></a-button>
          </a-dropdown>
        </a-space>
        <a-table
            size="small"
            :columns="columns"
            :row-key="record => record.id"
            :data-source="data"
            :row-selection="{ onChange: onSelectChange }"
            :pagination="pagination"
            :loading="loading"
            :transform-cell-text="$helper.emptyFormat"
            @change="handleTableChange"
        >
          <div slot="ip" slot-scope="record">
            <a-tooltip>
              <template slot="title">{{ record.ip }}</template>
              <span :class="record.region ? '' : 'text-red'">
                {{ record.region || '定位失败' }}
              </span>
            </a-tooltip>
          </div>
          <div slot="ua" slot-scope="record">
            <a-tooltip>
              <template slot="title">{{ record.user_agent }}</template>
              <a-tag>UA</a-tag>
            </a-tooltip>
          </div>
          <div slot="action" slot-scope="record" class="actions">
            <template v-if="accessTo(['update', 'destroy'])">
              <a-popconfirm title="确认要删除吗?" @confirm="destroy(record)" v-if="accessTo('destroy')">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template v-else>-</template>
          </div>
        </a-table>
      </a-layout-content>
    </a-layout>
  </a-modal>

</template>

<style lang="less" scoped>
@import 'Online';
</style>

<script>
import Online from './Online'
export default Online
</script>

